<template>
  <div class="member-active-curve flex-center">
    <!-- <slot></slot> -->
    <!-- <div :id="chartId" style="height: 15px; width: 100%"></div> -->
    <div class="curve-wrp">
      <div :id="chartId" style="height: 15px; width: 100%"></div>
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/common'
import { getMemberActiveApi } from '@/api/rms/rmsMemberDetailApi'
import { getBehavioractivationApi } from '@/api/up/upMemberApi'


export default {
  name: 'RmsMemberActiveCurve',
  props: {
    memberid: {
      type: Number,
      default: 0
    },

    show: {
      type: [Number, Boolean],
      default: true
    },
  },

  data() {
    return {
      unit: '',
      chart: null,
      chartOption: {
        tooltip: {
          show: false
        },
        grid: {
          top: 0,
          bottom: 2,
          right: 0,
          left: 0
        },
        xAxis: {
          type: 'time',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            lineStyle: {
              width: 1,
            },
            smooth: false,
            color: '#07c160',
            showSymbol: false,
            data: []
          }
        ]
      }
    }
  },

  computed: {
    chartId() {
      return `active-curve-${this.memberid}`
    }
  },

  watch: {
    // show(nval, oval) {
    //   console.log('watch show', this.chartId, nval, oval)
    //   if (this.show) {
    //     this.initChart()
    //     this.fetchData()
    //   } else {
    //     this.disposeChart()
    //   }
    // },

    memberid(nval, oval) {
      if (this.show) {
        // this.initChart()
        this.fetchData()
      } else {
        this.disposeChart()
      }
    }
  },

  created: function() {
    this.fetchData()
  },

  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  beforeDestroy() {
    this.disposeChart()
    window.removeEventListener('resize', this.__resizeHandler)
  },

  methods: {
    fetchData() {
      getBehavioractivationApi({ memberid: this.memberid }).then(res => {
        if (!res.errno) {
          this.chartOption.series[0].data = res.data

          if (this.chart) {
            this.chart.setOption(this.chartOption)
          }
        }
      })
    },

    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.chartId), 'teenager')
      this.chart.setOption(this.chartOption)
    },

    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = undefined
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.member-active-curve {
  position: relative;
  .curve-wrp {
    position: absolute;
    bottom: 23px;
    left: 0;
    right: 0;
  }
}
</style>
